import * as React from "react";
import styled, { css } from "styled-components";
import capitalize from "lodash/capitalize";
import { Alert, Button, Col, Row } from "components/bootstrap";
import { Spinner, LinkContainer } from "components/common";
import Routes from "routing/Routes";
import DocsHelper from "util/DocsHelper";
import { DocumentationLink } from "components/support";
import { useFailureProcessingOverview } from "failure/api/failureProcessing";
const FAILURES_STREAM_ID = "000000000000000000000004";
const Header = styled.div`
  display: flex;
  justify-content: space-between;
`;
const StatCount = styled.span(
  ({ $enabled }) => css`
    grid-column: 2;
    font-style: ${$enabled ? "normal" : "italic"};
  `
);
function FailureProcessingOverview() {
  const { data: overviewStats } = useFailureProcessingOverview();
  return /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(Header, null, /* @__PURE__ */ React.createElement("h2", null, "Indexing & Processing Failures"), /* @__PURE__ */ React.createElement(
    DocumentationLink,
    {
      page: DocsHelper.PAGES.INDEXER_FAILURES,
      text: "Indexer failures documentation",
      displayIcon: true
    }
  )), /* @__PURE__ */ React.createElement("p", { className: "description" }, "Every message that was not successfully indexed or processed will be logged as a failure."), /* @__PURE__ */ React.createElement("div", null, !overviewStats ? /* @__PURE__ */ React.createElement(Spinner, null) : Object.keys(overviewStats).map((key) => {
    const noErrors = overviewStats[key].count === 0;
    const isEnabled = overviewStats[key].enabled;
    const alertStyle = !isEnabled ? "info" : "success";
    const capitalizedKey = capitalize(key);
    const keyTitle = overviewStats[key].count === 0 ? `${capitalizedKey} is good` : `${capitalizedKey} has errors`;
    return /* @__PURE__ */ React.createElement(Alert, { key, bsStyle: noErrors ? alertStyle : "danger", title: keyTitle }, /* @__PURE__ */ React.createElement(StatCount, { $enabled: overviewStats[key].enabled }, overviewStats[key].enabled ? `${overviewStats[key].count.toLocaleString()} errors in the past 24 hours` : "Disabled", !noErrors && isEnabled ? /* @__PURE__ */ React.createElement(
      LinkContainer,
      {
        to: overviewStats[key].source === "mongodb" ? Routes.SYSTEM.INDICES.FAILURES : Routes.stream_search(FAILURES_STREAM_ID, `failure_type:${key}`, { relative: 86400 })
      },
      /* @__PURE__ */ React.createElement(Button, { bsStyle: "info", bsSize: "xs", className: "pull-right" }, "Show errors")
    ) : null));
  }))));
}
export default FailureProcessingOverview;
